// PRD.314 — PowerSync queries for the generic Specialty History relation.
//
// Kept separate from `specialty-history-logic.ts` (types, identity, selection)
// because that module must stay import-free to run under the node:test harness.
// Everything from there is re-exported here so callers have one entry point.

import type { QuerySpec } from '@helios/powersync-client-core';
import type { SpecialtyHistoryType } from './specialty-history-logic.js';

export * from './specialty-history-logic.js';

/**
 * Every specialty-history row of one type for one patient, across encounters.
 *
 * Ordering/filtering is done in `selectPriorSpecialtyHistory` so the same
 * chronology rules apply as for Medical History. Scoped to a single `type` so
 * dental narratives can never leak into the derma surface or vice versa.
 */
export function qSpecialtyHistoriesByPatient(
  patientId: string,
  type: SpecialtyHistoryType,
): QuerySpec<[string, string]> {
  return {
    key: ['encounter_specialty_histories', 'by-patient', patientId, type] as const,
    sql: `SELECT * FROM encounter_specialty_histories
          WHERE patient_id = ? AND type = ?`,
    params: [patientId, type],
    watch: ['encounter_specialty_histories'],
  };
}
